import { ca } from '@cian/analytics';
import { gaLabelSelector } from '../../selectors/';
import { TThunkAction } from '../../types/redux';

export function trackShowPhone(action: string): TThunkAction {
  return async (dispatch, getState) => {
    const state = getState();
    const gaLabel = gaLabelSelector(state);

    ca('eventSite', {
      action,
      category: 'Phones',
      label: gaLabel,
      name: 'oldevent',
      useLastProducts: true,
    });
  };
}

export function trackOpenContacts(): TThunkAction {
  return async (dispatch, getState) => {
    const state = getState();
    const gaLabel = gaLabelSelector(state);

    ca('eventSite', {
      action: 'open_contacts',
      category: 'CardJK',
      label: gaLabel,
      name: 'oldevent',
      useLastProducts: true,
    });
  };
}
